import { createFileRoute } from '@tanstack/react-router';

import { AdminPageContent } from '@/features/admin/components/AdminPageContent';
import {
  AdminPageHeader,
  BreadcrumbItemProps,
} from '@/features/admin/components/AdminPageHeader';
import { AlphaWrite } from '@/features/alpha-write/components/AlphaWrite';
import { PowerPath100Game } from '@/features/powerpath-quiz/components/PowerPath100Game';
import { PowerPathTest } from '@/features/powerpath-quiz/components/PowerPathTest';
import { useLessonType } from '@/features/powerpath-quiz/hooks';
import { LessonTypes } from '@/features/powerpath-quiz/types/powerpath-types';
import { useOneRosterAuth } from '@/hooks/useOneRosterAuth';

export const Route = createFileRoute('/_app/app/lesson/$lessonId')({
  component: RouteComponent,
  ssr: false,
  validateSearch: (search?: Record<string, unknown>) => {
    return {
      nextLessonType:
        (search?.nextLessonType as LessonTypes | undefined) ?? undefined,
      nextLesson: (search?.nextLesson as string | undefined) ?? undefined,
    };
  },
});

const breadcrumbItems: BreadcrumbItemProps[] = [
  {
    label: 'Lessons',
    link: { to: '/app' },
  },
  {
    label: 'Lesson',
    link: { to: '/app/lesson/$lessonId' },
  },
];

function RouteComponent() {
  const params = Route.useParams();
  const auth = useOneRosterAuth();
  const { data: lessonType, isLoading } = useLessonType(params.lessonId);

  const user = auth.user!;
  const returnLink = breadcrumbItems[breadcrumbItems.length - 2]?.link?.to;

  if (isLoading || !lessonType) {
    // TODO: Render a proper loader
    return <div>Loading...</div>;
  }

  const renderGameMode = () => {
    if (lessonType === LessonTypes.POWERPATH_100) {
      return (
        <PowerPath100Game
          key={params.lessonId}
          studentId={user.sourcedId}
          studentEmail={user.email}
          lessonId={params.lessonId}
          returnLink={returnLink}
          trackTimeSpent={true}
        />
      );
    } else if (
      lessonType === LessonTypes.QUIZ ||
      lessonType === LessonTypes.UNIT_TEST ||
      lessonType === LessonTypes.TEST_OUT ||
      lessonType === LessonTypes.PLACEMENT
    ) {
      return (
        <PowerPathTest
          key={params.lessonId}
          studentId={user.sourcedId}
          studentEmail={user.email}
          lessonId={params.lessonId}
          returnLink={returnLink}
          trackTimeSpent={true}
        />
      );
    } else if (lessonType === LessonTypes.ALPHA_WRITE) {
      return (
        <AlphaWrite
          lessonId={params.lessonId}
          userId={user.sourcedId}
          stimulusId={params.lessonId}
          courseId="ALPHAWRITE-SENTENCES-1"
        />
      );
    } else {
      return <div>Unknown lesson type: {lessonType}</div>;
    }
  };

  return (
    <>
      <AdminPageContent className="overflow-hidden">
        <AdminPageHeader breadcrumbItems={breadcrumbItems} />
        {renderGameMode()}
      </AdminPageContent>
    </>
  );
}
